import React from 'react';
import { Modal, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { ProfileData } from '../../../types/knowledge-base.ts';

interface ProfileModalProps {
    show: boolean;
    onHide: () => void;
    profileData: ProfileData;
    onUpdate: (e: React.FormEvent) => Promise<void>;
    onChange: (data: Partial<ProfileData>) => void;
    error: string | null;
    success: string | null;
    isLoading: boolean;
}

const ProfileModal: React.FC<ProfileModalProps> = ({
                                                       show,
                                                       onHide,
                                                       profileData,
                                                       onUpdate,
                                                       onChange,
                                                       error,
                                                       success,
                                                       isLoading
                                                   }) => {
    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Edit Profile</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                {success && <Alert variant="success">{success}</Alert>}
                <Form onSubmit={onUpdate}>
                    <Form.Group className="mb-3">
                        <Form.Label>Full Name</Form.Label>
                        <Form.Control
                            type="text"
                            value={profileData.fullName}
                            onChange={(e) => onChange({fullName: e.target.value})}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="email"
                            value={profileData.email}
                            disabled
                            readOnly
                        />
                    </Form.Group>
                    <div className="d-flex justify-content-end gap-2">
                        <Button variant="secondary" type="button" onClick={onHide}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit" disabled={isLoading}>
                            {isLoading ? (
                                <>
                                    <Spinner size="sm" className="me-2"/>
                                    Updating...
                                </>
                            ) : 'Update Profile'}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default ProfileModal;